import React from 'react'
import VideoCover from 'react-video-cover';
import { StHero } from './style.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Image from '../../components/Image';

const clickScroll = (to) => {
  if (typeof window !== 'undefined') {
    window.scrollTo({
      top: to ? window.innerHeight * to : window.innerHeight,
      left: 0,
      behavior: 'smooth'
    });
  }
}

const Hero = (props) => {
  console.log(props)
  const { videosrc, imgfilename, children, minheight, to } = props

  return (
    <StHero minheight={minheight} onClick={() => clickScroll(to)}>
      <div className="hero-content">
        <div className="hero-wrap">
          {children}
        </div>
        <div className="hero-more">
          {/* <FontAwesomeIcon className="icon" icon={[ 'fas', 'arrow-down' ]} /> */}
        </div>
      </div>
      <div className="hero-bg">
        {videosrc && <VideoCover videoOptions={{
          src: videosrc,
          autoPlay: true,
          muted: true,
          loop: true,
          playsInline: true,
        }} />}
        {imgfilename && <Image filename={imgfilename} alt="" />}
      </div>
    </StHero>
  )
}

export default Hero